import { createApiRef } from '@mainstage/core-plugin-api';

export interface PlatformInfo {
  version?: string;
  license: {
    modules: string[];
    activeModules: string[];
    expirationDate: string;
    licensedUsers?: string;
  };
}

export type RequestOptions = {
  token?: string;
};

export interface InfoApi {
  setModulesOverride: (modules: string[]) => Promise<void>;
  getInfo: (options: RequestOptions) => Promise<PlatformInfo>;
}

export const infoApiRef = createApiRef<InfoApi>({
  id: 'plugin.wb.platform.info.service',
});
